<template>
  <div>
    <div class="titlePage">Solicitações de Correção Cadastral</div>
    <template v-if="idNotificacao == 0">
      <div class="row mt-3">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fieldsSolicitacoes"
            :orderby="sortBy"
            :actions="actionsSolicitacoes"
            :items="lstSolicitacoes"
            responsive
            :porPage="itemPorPage"
            :titlePage="titlePage"
            :titlePDF="titlePage"
          ></fccTable>
        </div>
      </div>
    </template>
    <template v-else>
      <FccListaCorrecaoCadastral
        @zerarSolicitacao="zerarSolicitacao"
        :controlePage="controlePage"
        :baseUrlPublicacao="baseUrlPublicacao"
        :idNotificacao="idNotificacao"
      />
    </template>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import FccListaCorrecaoCadastral from './fccListaCorrecaoCadastral.vue'

export default {
  data() {
    return {
      titlePage: 'Publicações',
      baseUrlPublicacao: '',
      sortBy: 'nome',
      itemPorPage: '1000',
      idNotificacao: 0,
      actionsSolicitacoes: [
        {
          button: true,
          funcaoButton: 'visualizaSolicitacao',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      lstSolicitacoes: [],
      fieldsSolicitacoes: [
        { key: 'numero', label: 'Nº', sortable: true },
        { key: 'tipodepublicacao', label: 'Tipo de Publicação	', sortable: true },
        { key: 'solicitante', label: 'Solicitante', sortable: true },
        { key: 'datasolicitacao', label: 'Data de Solicitação' },
        { key: 'datapublicacao', label: 'Data de Publicação' },
        { key: 'tecniconapd', label: 'Técnico NAPD' },
        { key: 'processo', label: 'Processo' },
        { key: 'statusfinal', label: 'Status' }
      ]
    }
  },
  components: { FccListaCorrecaoCadastral },
  methods: {
    zerarSolicitacao(number) {
      this.idNotificacao = number
    },
    visualizaSolicitacao(_, item) {
      this.idNotificacao = item.numero
    },
    listarCorrecao() {
      axios
        .get(
          store.state.baseUrlPublicacao +
            'PublicacaoCorrecaoCadastral/SolicitanteCorrecaoCadastral/' +
            this.controlePage.spi,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          if (response.status == 200) {
            this.lstSolicitacoes = response.data
            if (this.lstSolicitacoes.length > 0) {
              this.lstSolicitacoes.forEach(function (data) {
                data['statusfinal'] = data['status']
                delete data['status']
              })
            }
          }
        })
        .catch(this.setErrorSystem)
    }
  },
  props: {
    controlePage: Object
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.idNotificacao = 0
    this.listarCorrecao()
  }
}
</script>
